import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useSetShopFlagMutation = createMutationHook(ShopsApiClient.setShopFlag, {
  mutationKey: ['setShopFlag'],
})
